<template>
    <div class="aggregateTable-content">
        <!-- 头部 -->
        <div class="aggregateTable-content-top">
            <div class="tit">{{aggregateTableConfigData.modelTit}}</div>
            <div class="btn"><el-button type="primary" @click="saveData">保存数据</el-button></div>
        </div>
        <!-- 下面 -->
        <div class="aggregateTable-content-main">
            <div class="aggregateTable-content-main-left">
               <div style="height: 30px;" >
                   <el-popover
                        placement="right"
                        title="使用说明："
                        width="900"
                        trigger="hover"
                        >
                          <el-table :data="rulesData" border>
                            <el-table-column width="200" property="ruleType" label="规则类型"></el-table-column>
                            <el-table-column  property="desc" label="规则说明"></el-table-column>
                          </el-table>
                          <!-- type="success" effect="dark" -->
                          <el-tag slot="reference" >使用说明</el-tag>
                      </el-popover>
                </div>
                <div class="aggregateTable-content-main-left-item">
                    <div class="item-lable requireClass">聚合表名称</div>
                    <div class="item-content">
                        <el-input placeholder="请输入内容" v-model.trim="modelData.modelName"></el-input>
                    </div>
                </div>
                <div class="aggregateTable-content-main-left-item">
                    <div class="item-lable">聚合表描述</div>
                    <div class="item-content">
                        <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="modelData.remarks" />
                    </div>
                </div>
                <div class="aggregateTable-content-main-left-item" style="margin-top: 10px;">
                    <div class="item-lable requireClass">数据来源</div>
                    <div class="item-content">
                        <el-radio v-model="modelData.dataSourceType" :label="0" @change="initFormList" :disabled="canChoose">表单</el-radio>
                        <el-radio v-model="modelData.dataSourceType" :label="2" @change="initFormList" :disabled="canChoose">报表</el-radio>
                    </div>
                </div>
                <div class="aggregateTable-content-main-left-item">
                    <div class="item-lable requireClass">数据模型</div>
                    <div class="item-content" style="height: 30px;line-height: 30px;">
                        <TreeSelect
                            :key="dataSourceLoadTimer"
                            placeholder="请选择模型"
                            ref="treeSelect"
                            :multiple="false"
                            :disableBranchNodes="true"
                            :sourceOptions="appModelsOptions"
                            @treeSelectChoose="treeSelectChoose"
                        />
                    </div>
                </div>
                <div class="aggregateTable-content-main-left-item">
                    <div class="item-lable requireClass">选择源字段</div>
                    <div class="item-content">
                      <el-select
                          v-model="modelData.selectTargetColumns"
                          :multiple="true"
                          :disabled="isCanSelect"
                          filterable
                          placeholder="请选择聚合表字段"
                          @change="chooseTargetColumns"
                          style="width: 100%;">
                          <el-option-group
                            v-for="(item, index) in targetColumnsData"
                            :key="index"
                            :label="item.name">
                            <el-option
                                v-for="(cur, curIndex) in item.options"
                                :key="curIndex"
                                :label="modelData.dataSourceType === 2 ? cur.name + '【' + cur.formName + '】' : cur.name"
                                :value="cur.id"
                            >
                            </el-option>
                          </el-option-group>
                      </el-select>
                    </div>
                </div>
            </div>
            <div class="aggregateTable-content-main-right">
                <div class="customAggregateConfig-detail">
                  <!-- <el-collapse accordion>
                      <el-collapse-item>
                        <template slot="title">
                         <el-tag style="margin-left:10px" class="header-icon el-icon-info">使用说明</el-tag>
                        </template>
                        <el-table :data="rulesData" border>
                          <el-table-column width="200" property="ruleType" label="规则类型"></el-table-column>
                          <el-table-column  property="desc" label="规则说明"></el-table-column>
                        </el-table>
                      </el-collapse-item>
                  </el-collapse> -->
                    <el-card class="box-card model-desc" shadow="always">
                        <!-- <div class="topSetting">
                            <el-button icon="el-icon-view" :disabled="modelData.selectTargetColumns.length===0" type="primary" @click="handleFilterField()">设置聚合字段</el-button>
                            <el-button icon="el-icon-files" :disabled="modelData.selectTargetColumns.length===0" type="success" @click="fillterCondtionSearch()">数据过滤条件</el-button>
                            <el-button icon="el-icon-search" :disabled="modelData.selectTargetColumns.length===0"  type="info" @click="handleFilterCondition()">设置查询条件</el-button>
                        </div> -->
                        <el-form :inline="true" :model="modelData" class="demo-form-inline">
                          <el-form-item label="">
                            <el-button icon="el-icon-view" :disabled="modelData.selectTargetColumns.length===0" title='先选择源字段后可点击设置' type="primary" @click="handleFilterField()">设置聚合字段</el-button>
                            <el-button icon="el-icon-files" :disabled="modelData.selectTargetColumns.length===0" title='先选择源字段后可点击设置' type="success" @click="fillterCondtionSearch()">数据过滤条件</el-button>
                            <el-tooltip class="item" effect="dark" content="设置当前聚合表根据月、季度、年来进行查询条件的时间类型字段" placement="top">
                              <el-button icon="el-icon-time" type="primary" @click="handleFilterTimeSetting()">时间设置</el-button>
                          </el-tooltip>
                            <!-- <el-button icon="el-icon-search" :disabled="modelData.selectTargetColumns.length===0"  title='先选择源字段后可点击设置' type="info" @click="handleFilterCondition()">设置查询条件</el-button> -->
                          </el-form-item>
                          <!-- <el-form-item label="聚合表名称"
                                :rules="[
                                  { required: true, message: '名称不能为空'},
                                ]"
                          >
                            <el-input v-model="modelData.modelName" placeholder="请输入内容"></el-input>
                          </el-form-item>
                          <el-form-item label="聚合表描述">
                            <el-input type="textarea" v-model="modelData.remarks" placeholder="请输入内容"></el-input>
                          </el-form-item> -->
                        </el-form>
                        <!-- <div class="topSetting">
                            <div class="text-desc desc-content2">
                                <el-row style="margin-bottom: 20px">
                                    <el-button v-if="modelData.formId!=''&&modelData.formId!=undefined" icon="el-icon-d-arrow-right" type="success" @click="handleBusinessApplication" round>进入业务应用</el-button>
                                </el-row>
                            </div>
                        </div> -->
                    </el-card>
                    <el-card v-if="isShowtableColumnsList" class="box-card model-desc" shadow="always">
                      <div class="model-content">
                        <div class="content-left">
                          <template >
                              聚合表显示字段列表
                              <div class="canDropTable1" >
                                  <DynamicTable
                                      :key="tableLoadTimer"
                                      :tableColumns="tableColumns"
                                      :dragTableColumns="modelData.dragTableColumns"
                                      :tableData="pageData"
                                      :isShowCheckbox="false"
                                      :isSortable="true"
                                      :tableHeight="'200px'"
                                    >
                                  </DynamicTable>
                                </div>
                          </template>
                                <!-- <pre style="text-align: left">
                                  {{modelData.dragTableColumns}}
                                </pre> -->
                        </div>

                        <!-- <el-dialog
                            title="编辑文件标签"
                            append-to-body
                            :visible.sync="isShowTag">
                            <FileTag
                                ref="fileTag"
                                :selectTags="selectTags"
                                :templateId="''"
                                :key="loadTimer"
                                :processInstanceId="''"
                            />
                            <span slot="footer" class="dialog-footer">
                                <el-button @click="isShowTag = false">取 消</el-button>
                                <el-button type="primary" @click="handleSaveTag">确 定</el-button>
                            </span>
                        </el-dialog> -->

                        <el-dialog
                            title="选择显示字段"
                            :visible.sync="isShowFilterField">
                            <SelectMultiple  ref="selectMultiple" :sourceOptions="sourceOptions"  :selectViewFields="selectViewFields" :isGroup="true" />
                            <span slot="footer" class="dialog-footer">
                                <el-button @click="isShowFilterField = false">取 消</el-button>
                                  <!-- <el-button @click="resetViewFields">重置</el-button> -->
                                <el-button type="primary" @click="chooseViewFields">确 定</el-button>
                            </span>
                        </el-dialog>

                        <!-- <el-dialog
                            title="设置查询条件"
                            top="4vh"
                            custom-class="search-box"
                            :visible.sync="isShowSearchConditon">
                            <SearchCondition  ref="searchConditon" :conditionFields="conditionFields"  />
                            <span slot="footer" class="dialog-footer">
                                <el-button @click="isShowSearchConditon = false">取 消</el-button>
                                <el-button @click="resetSearchConditon">重置</el-button>
                                <el-button type="primary" @click="chooseSearchConditon">确 定</el-button>
                            </span>
                        </el-dialog> -->
                    </div>
                    </el-card>
                    <el-card  v-if="isShowTag" class="box-card model-desc" shadow="always">
                          <el-form :inline="true" :model="selectedAggField" class="demo-form-inline">
                            <el-row>
                              <el-form-item label="">
                                <CustomAggregateColumnTag
                                      ref="fileTag"
                                      :selectTags="selectTags"
                                      :key="loadTimer"
                                      :formId="this.aggregateTableConfigData.formId"
                                      @synAddFileds="synAddFileds"
                                      @synDelFileds="synDelFileds"
                                      @synConfigFileds="synConfigFileds"
                                    />
                              </el-form-item>
                            </el-row>
                            <el-row v-if="selectedAggField.id!==''">
                              <el-col :span="6">
                                <el-form-item label="当前字段">
                                  <el-input  v-model="selectedAggField.name" ></el-input>
                                   <!-- <el-tag style="cursor:pointer;" effect="dark" type="warning" :disable-transitions="false">
                                          {{selectedAggField.name}}
                                  </el-tag> -->
                                </el-form-item>
                               </el-col>
                              <el-col :span="18">
                                <el-form-item label="统计模式">
                                      <el-radio-group v-model="selectedAggField.calculType" size="mini" class="exec-type">
                                        <el-radio :label="0">单列统计</el-radio>
                                        <el-radio :label="1">跨列统计</el-radio>
                                    </el-radio-group>
                                </el-form-item>
                              </el-col>
                            </el-row>
                            <el-row v-if="selectedAggField.id!=='' && selectedAggField.calculType===0">
                                <el-col :span="6">
                                    <el-form-item label="维度">
                                        <el-select v-model="selectedAggField.selectXdata" filterable clearable placeholder="请选择维度字段" @change="changeXdata"  style="width: 100%;">
                                            <el-option-group
                                              v-for="(item, index) in targetColumnsData"
                                              :key="index"
                                              :label="item.name">
                                              <el-option
                                                  v-for="(cur, curIndex) in item.options"
                                                  :key="curIndex"
                                                  :label="modelData.dataSourceType === 2 ? cur.name + '【' + cur.formName + '】' : cur.name"
                                                  :value="cur.id"
                                              >
                                              </el-option>
                                            </el-option-group>
                                        </el-select>
                                    </el-form-item>
                                  </el-col>
                                  <el-col :span="6">
                                    <el-form-item label="指标">
                                        <el-select v-model="selectedAggField.selectYdata" filterable value-key="id" clearable placeholder="请选择指标字段" @change="changeYdata" style="width: 100%;">
                                          <el-option-group
                                            v-for="(item, index) in targetColumnsData"
                                            :key="index"
                                            :label="item.name">
                                            <el-option
                                                v-for="(cur, curIndex) in item.options"
                                                :key="curIndex"
                                                :label="modelData.dataSourceType === 2 ? cur.name + '【' + cur.formName + '】' : cur.name"
                                                :value="cur.id"
                                            >
                                            </el-option>
                                          </el-option-group>
                                        </el-select>
                                        <el-input v-if="selectedAggField.selectYdata" placeholder="请输入指标过滤值" v-model="selectedAggField.selectYdataFilterVal" clearable ></el-input>
                                    </el-form-item>
                                  </el-col>
                                  <el-col :span="12">
                                    <el-form-item label="计算方式">
                                      <!-- style="width: 160px"  -->
                                        <el-select v-model="selectedAggField.calculVal"  value-key="id" placeholder="数据处理模式" @change="changeOpreaYdata">
                                          <el-option
                                            v-for="item in opreaYdata"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                            </el-option>
                                        </el-select>
                                        <el-select  v-model="selectedAggField.unitsetting" filterable clearable value-key="id" placeholder="单位处理">
                                          <el-option
                                            v-for="item in unitsettingData"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                            </el-option>
                                        </el-select>
                                        <el-select v-if="selectedAggField.calculVal===2||selectedAggField.calculVal===3||selectedAggField.calculVal===4" v-model="selectedAggField.repeatedFilteringField" filterable value-key="id" clearable placeholder="请选择指标过滤字段" @change="changeYdata" style="width: 100%;">
                                          <el-option-group
                                            v-for="(item, index) in targetColumnsData"
                                            :key="index"
                                            :label="item.name">
                                            <el-option
                                                v-for="(cur, curIndex) in item.options"
                                                :key="curIndex"
                                                :label="modelData.dataSourceType === 2 ? cur.name + '【' + cur.formName + '】' : cur.name"
                                                :value="cur.id"
                                            >
                                            </el-option>
                                          </el-option-group>
                                        </el-select>
                                    </el-form-item>
                                  </el-col>
                            </el-row>
                            <el-row v-if="selectedAggField.id!=='' && selectedAggField.selectYdata!=='' && selectedAggField.calculType===0">
                                  <el-col :span="6">
                                    <el-form-item label=""></el-form-item>
                                  </el-col>
                                  <el-col :span="6">
                                    <el-tooltip class="item" effect="dark" content="设置了查询字段后，在聚合表点击统计数据时，会按照对应的字段去对应的表单里查询聚合数据的明细内容" placement="top">
                                      <el-form-item label="设置聚合查询条件">
                                        <el-select  :key="aggregateFieldsLoadTimer" v-model="selectedAggField.aggregateSearchConditionId" filterable value-key="id" clearable placeholder="请选择查询字段" style="width: 100%;">
                                          <el-option
                                            v-for="item in aggregateSearchConditionFields"
                                            :key="item.id"
                                            :label="item.name"
                                            :value="item.id">
                                            </el-option>
                                        </el-select>
                                      </el-form-item>
                                    </el-tooltip>
                                  </el-col>
                                  <el-col :span="12">
                                    <el-form-item label=""></el-form-item>
                                  </el-col>
                            </el-row>
                             <el-row v-if="selectedAggField.id!=='' && selectedAggField.calculType===1">
                                <el-col :span="12">
                                  <el-form-item label="公式">
                                    <el-input style="width: 320px;" :rows="3" readonly type="textarea"   v-model="selectedAggField.formulaRule" ></el-input>
                                    <el-button  type="primary" icon="el-icon-circle-plus" title="编辑公式" @click="handleSaveCalculation">编辑公式</el-button>
                                  </el-form-item>
                                </el-col>
                               <el-col :span="12">
                                <el-form-item label="描述">
                                  <el-input style="width: 320px;" type="textarea" :rows="3" v-model="selectedAggField.formulaDesc" placeholder="请输入内容"></el-input>
                                </el-form-item>
                              </el-col>

                            </el-row>
                          </el-form>
                      </el-card>
                  </div>
            </div>
        </div>
        <!-- 侧滑 -->
        <div class="aggregateTable-content-other">
            <el-drawer
              :visible.sync="isShowBiSearchSetting"
              title="配置搜索条件"
              :direction="direction"
              size="25vw"
                >
                 <div class="search-field" style="height: 100%;">
                     <SearchCondition
                         ref="searchConditon"
                         :key="searchLoadTimer"
                         :isShowLeftModel="false"
                         :conditionFields="conditionFields"
                         :class="'search-field-box'"
                         :style="'height:82vh;overflow:auto;'"
                         >
                     </SearchCondition>
                 </div>
                 <div class="opt" style="position: fixed;bottom: 20px;text-align: center;left: 7vw;">
                     <el-button @click="celSetForm">取消</el-button>
                     <el-button @click="resetSearchConditon">重置</el-button>
                     <el-button type="success" @click="subSetForm">确定</el-button>
                 </div>
            </el-drawer>
        </div>
         <el-dialog
            title="编辑计算公式"
            width="70%"
            top="5vh"
            append-to-body
            :visible.sync="isShowFormula">
            <Formula  :key="loadTimer" ref="formula"  :isSummary="isSummary" :content="content" :sourceOptions="sourceOptions" :subFieldSelected = "subFieldSelected"   />
            <span slot="footer" class="dialog-footer">
                <el-button  @click="isShowFormula = false">取 消</el-button>
                <el-button  type="primary" @click="saveFormula">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog
          title="设置时间条件"
          top="4vh"
          append-to-body
          custom-class="search-box"
          :visible.sync="isTimeSettingFields">
          <SearchCondition    :key="loadTimer" ref="timeSettingFields" :conditionFields="timeSettingFields"  :timeSettingFields="timeSettingFields"   @chooseTimeSettingFields="chooseTimeSettingFields" />
          <span slot="footer" class="dialog-footer">
              <el-button @click="isTimeSettingFields = false">取 消</el-button>
              <el-button @click="resetTimeSettingFields">重置</el-button>
              <el-button type="primary" @click="chooseTimeSettingFields">确 定</el-button>
          </span>
      </el-dialog>
    </div>
</template>

<script>
import { isEmpty, cloneDeep } from 'lodash';
import Sortable from 'sortablejs';
import DashBoard from '@/components/DashBoard';
import CustomAggregateColumnTag from './CustomAggregateColumnTag';
import SearchConditionSide from '@/components/SearchCondition/SearchConditionSide';
import { getFormConfig, getApplicationModelTreeList, getBIFormConfigs, getFormAggregateTableConfig, getModelFormReportList, getFormFieldListByIds } from '@/data-model';
import { add } from '@/utils/http/request-record';
export default {
    name: 'CustomAggregateTable',
    comments: {
        DashBoard: DashBoard,
        SearchCondition: SearchConditionSide
    },
    components: {
        Sortable,
        CustomAggregateColumnTag
    },
    props: {
        aggregateTableConfigData: {
            type: Object,
            default: () => {
                return {
                    modelTit: '',
                    appId: '',
                    formId: '',
                    modelName: '',
                    remarks: '',
                    modelId: '',
                    selectFormId: '',
                    selectModelId: ''
                };
            }
        }
    },
    mounted () {
        // document.body.ondrop = function (event) {
        //     event.preventDefault();
        //     event.stopPropagation();
        // };
        // this.rowDrop();
        this.columnDrop();
    },
    data () {
        return {
            allformulaFields: [], // 计算公式时使用的所有字段,包括源数据字段和新增聚合字段
            opreaYdata: [{ id: 1, name: '原值显示' }, { id: 2, name: '计数统计' }, { id: 3, name: '加和统计' }, { id: 4, name: '平均统计' }],
            unitsettingData: [{ id: 1, name: '原值显示' }, { id: 2, name: '详细时间(天/时/分/秒)' }, { id: 3, name: '小时时间(小时)' }],
            isShowFormula: false,
            isSummary: false,
            sourceOptions: [],
            subFieldSelected: {},
            selectedAggField: {
                id: '',
                name: '',
                formulaView: '',
                formulaDesc: '',
                formulaRule: '',
                selectXdata: '', // 维度字段
                calculVal: 0, // 聚合处理模式
                unitsetting: 1
            },
            rulesData: [{
                ruleType: '1. 选择数据源和数据模型',
                desc: '通过左侧的数据源类型，确定是表单还是报表，然后查找出本次制作聚合表需要的数据源模型。'
            }, {
                ruleType: '2. 选择源字段',
                desc: '找到数据源后，根据数据源内的字段内容，挑选本次制作聚合表所需要的字段。'
            }, {
                ruleType: '3. 设置聚合字段',
                desc: '选择数据源里的源字段，可以配置公式得出聚合字段，可以动态拖拽列进行字段排序，在计算公式框中可以使用 + - * / ( ) 进行组合编写公式。'
            },
            {
                ruleType: '4. 设置过滤条件',
                desc: '当设置好过滤条件后，在使用态下查看当前聚合表时，数据已经经过设置的条件自动过滤了。'
            }, {
                ruleType: '5. 设置查询条件',
                desc: '使用态下查看当前聚合表时，自动展现出所设置的查询条件，便于快速查询聚合表。'
            }
            ],
            loadTimer: '',
            selectTags: [],
            isShowTag: false,
            isShowtableColumnsList: false,
            selectViewFields: [],
            pageData: [],
            isShowFilterField: false,
            modelData: {
                modelName: '',
                remarks: '',
                dataSourceType: 0,
                formIds: '',
                modelIds: '',
                id: '',
                formId: '',
                modelId: '',
                selectFormId: '',
                selectModelId: '',
                selectTargetColumns: [],
                dragTableColumns: [],
                fieldFormulas: [],
                searchConditionFields: [],
                timeSettingFields: [],
                viewConditionFields: []
            },
            dataSourceLoadTimer: '',
            tableLoadTimer: '',
            searchLoadTimer: '',
            aggregateFieldsLoadTimer: '',
            chartType: 1,
            appModelsOptions: [],
            targetColumnsData: [],
            YData: [],
            searchData: [],
            formatXDateFieldVal: '',
            formatXDateFieldObj: {},
            cakeData: [],
            selectStatisticsYfield: '',
            selectYdata: '',
            selectSearchData: [],
            selectOpreaYdata: '',
            selectCakedata: '',
            isCanSelect: true,
            showChooseFormatXDateField: false,
            formData: {},

            chartSettings: {},
            dashboardSetting: {},
            dashboardData: {},
            modelId: '',
            allChooseContrastData: [],
            initData: 0,
            id: '',
            canChoose: false,
            showBiWay: '0',
            isShowBiSearchSetting: false,
            direction: 'ltr',
            conditionFields: [],
            tableColumns: [],
            searchParams: {
                modelId: '',
                name: '',
                selectedFields: '',
                searchCondition: [],
                selectedApprovalStatus: '',
                formId: ''
            },
            formPage: {
                currentPage: 1, // 当前页码
                pageSize: 10, // 每页条数
                totalPageNum: 1 // 总页数
            },
            allFields: [],
            dashboardPattern: 1,
            currItem: {},
            sortColumnTimer: '',
            aggFiledsList: [], // 当前聚合字段列表
            content: {// 计算公式显示内容
                txt: ''
            },
            isTimeSettingFields: false,
            isRefreshTimeSetting: true,
            timeSettingFields: [],
            isShowRelationship: false,
            originalTimeSettingFields: [],
            aggregateSearchConditionFields: []
        };
    },
    watch: {
        'selectedAggField.name' (newVal, oldVal) {
            this.selectTags.forEach(item => {
                if (this.selectedAggField.id === item.id) {
                    item.label = newVal;
                    item.name = newVal;
                }
            });
            this.tableColumns.forEach(item => {
                if (this.selectedAggField.id === item.id) {
                    item.label = newVal;
                    item.name = newVal;
                }
            });
            this.modelData.dragTableColumns.forEach(item => {
                if (this.selectedAggField.id === item.id) {
                    item.label = newVal;
                    item.name = newVal;
                }
            });
        }
    },
    created () {
        if (this.aggregateTableConfigData.formId) {
            this.modelData.modelName = this.aggregateTableConfigData.modelName;
            this.modelData.remarks = this.aggregateTableConfigData.remarks;
            // 修改
            this.canChoose = true;
            this._initAggTableData();
        } else {
            // 新增
            this._initPage();
        }
    },
    methods: {
        // // 行拖拽
        // rowDrop () {
        //     // 此时找到的元素是要拖拽元素的父容器
        //     const tbody = document.querySelector('.canDropTable table tbody');
        //     const _this = this;
        //     Sortable.create(tbody, {
        //         //  指定父元素下可被拖拽的子元素
        //         draggable: '.el-table__row',
        //         onEnd ({ newIndex, oldIndex }) {// 可以复制 tableColumns出来，避免和列混淆
        //             const currRow = _this.tableColumns.splice(oldIndex, 1)[0];
        //             _this.tableColumns.splice(newIndex, 0, currRow);
        //         }
        //     });
        // },
        // 列拖拽
        columnDrop () {
            if (this.modelData.dragTableColumns.length > 1) {
                const wrapperTr = document.querySelector('.canDropTable1 table tr');
                this.sortable = Sortable.create(wrapperTr, {
                    animation: 180,
                    delay: 0,
                    onEnd: evt => {
                        const oldItem = this.modelData.dragTableColumns[evt.oldIndex];
                        this.modelData.dragTableColumns.splice(evt.oldIndex, 1);
                        this.modelData.dragTableColumns.splice(evt.newIndex, 0, oldItem);
                    }
                });
            }
        },
        async _initAggTableData () {
            this.isCanSelect = false;
            let formId = this.aggregateTableConfigData.formId;
            let obj = await getFormAggregateTableConfig(formId);
            if (obj.aggregateTableConfig) {
                this.modelData = cloneDeep(obj.aggregateTableConfig);
                this.modelData.selectTargetColumns = obj.aggregateTableConfig.selectTargetColumns ? JSON.parse(obj.aggregateTableConfig.selectTargetColumns) : [];
                this.modelData.dragTableColumns = obj.aggregateTableConfig.dragTableColumns ? JSON.parse(obj.aggregateTableConfig.dragTableColumns) : [];
                this.modelData.fieldFormulas = obj.aggregateTableConfig.fieldFormulas ? JSON.parse(obj.aggregateTableConfig.fieldFormulas) : [];
                this.modelData.searchConditionFields = obj.aggregateTableConfig.searchConditionFields ? JSON.parse(obj.aggregateTableConfig.searchConditionFields) : [];
                this.modelData.timeSettingFields = obj.aggregateTableConfig.timeSettingFields ? JSON.parse(obj.aggregateTableConfig.timeSettingFields) : [];
                this.modelData.viewConditionFields = obj.aggregateTableConfig.viewConditionFields ? JSON.parse(obj.aggregateTableConfig.viewConditionFields) : [];
                this.conditionFields = this.modelData.searchConditionFields;
                // console.log(this.modelData);
                let selected = {};
                selected.id = this.modelData.selectModelId;
                selected.formId = this.modelData.selectFormId;
                this.$refs.treeSelect.initParam(this.modelData.selectModelId);
                await this.treeSelectChoose(selected, true);
                this.selectTags = this.modelData.fieldFormulas;
                if (!isEmpty(this.selectTags)) {
                    this.synConfigFileds(this.selectTags[0]);
                }

                this.isShowTag = true;
                await this._initModelTree();
            } else {
                this.messageTip('找不到对应的聚合表配置', 'warning');
            }
        },
        async handleSaveTag () {
            this.isShowTag = false;
            // let taskFile = {id: ''};
            let idArr = [];
            this.selectTags.forEach(item => {
                idArr.push({tagId: item.id, label: item.label, tagFlg: item.tagFlg});
            });
            // taskFile.tags = idArr;
            // await saveTags(taskFile);
            // this.handleFileSearch();
        },
        handleFilterField () {
            this.loadTimer = new Date().getTime();
            if (isEmpty(this.tableColumns)) {
                this.messageTip('请在左侧选择聚合表的字段', 'warning');
                return;
            }
            // if (fileobj.id !== this.selectedRow.id) {
            //     this.selectTags = [];
            //     this.selectedRow = fileobj;
            //     if (fileobj.tagIds) { // 标签树、模板树
            //         let tagIds = fileobj.tagIds.split(',');
            //         let tagLabels = fileobj.tagLabels.split(',');
            //         for (var i = 0, len = tagIds.length; i < len; i++) {
            //             // this.selectTags.push({id:'0-'+tagIds[i],label:tagLabels[i],tagFlg:0});
            //             this.selectTags.push({id: tagIds[i], label: tagLabels[i], tagFlg: tagIds[i].substring(0, 1)});
            //         }
            //     }
            //     setTimeout(() => {
            //         this.$refs.fileTag.initData();
            //     }, 0);
            // }
            if (this.isShowTag) {
                this.isShowTag = false;
            } else {
                this.isShowTag = true;
            }
            // console.log(this.selectTags);
        },
        handleFilterCondition () {

        },
        async _initPage (obj) {
            await this._initModelTree();
            this.dataSourceLoadTimer = new Date().getTime();
            this.allformulaFields = [];
        },
        async _initModelTree () {
            let modelTree = await getApplicationModelTreeList({
                currentPage: 1,
                pageSize: 100,
                state: 1,
                modelType: this.modelData.dataSourceType
            });
            this.appModelsOptions = modelTree;
        },
        initFormList () {
            this._initPage();
            this.initSelectData();
        },
        initSelectData () {
            this.tableColumns = [];
            this.modelData.dragTableColumns = [];
            this.modelData.selectTargetColumns = [];
            this.modelData.selectFormId = '';
            this.modelData.selectModelId = '';
        },
        async treeSelectChoose (selected, init) {
            // 选择好数据源后
            if (selected) {
                this.modelData.selectFormId = selected.formId;
                this.modelData.selectModelId = selected.id;
                this.initField(selected, init);
            }
        },
        async initField (selected, init) {
            var param = { formId: this.modelData.selectFormId, BIDimension: this.modelData.dataSourceType };
            let field = await getBIFormConfigs(param);
            let formArr = [];
            let formItem = {};
            let parArr = [];
            this.allFields = [];
            for (let i = 0; i < field.allList.length; i++) {
                let cur = field.allList[i];
                cur.prop = cur.id;
                cur.label = cur.name;
                if (cur.type === 'subform' && cur.options && cur.options.fieldList) { // 子表单
                    let arr = cur.options.fieldList;
                    let sunArrId = cur.id;
                    let formChildArr = [];
                    for (let j = 0; j < arr.length; j++) {
                        let sunObj = arr[j];
                        sunObj.parentId = sunArrId;
                        sunObj.fieldType = 'childForm';
                        sunObj.prop = sunObj.id;
                        sunObj.label = sunObj.name;
                        formChildArr.push(sunObj);
                        this.allFields.push(sunObj);
                    }
                    let sunName = cur.name;
                    let item = {};
                    item.name = sunName;
                    item.options = formChildArr;
                    formArr.push(item);
                } else { // 非子表单字段
                    cur.parentId = cur.id;
                    cur.fieldType = 'parentForm';
                    parArr.push(cur);
                    this.allFields.push(cur);
                }
            }
            formItem.name = '主表单字段';
            formItem.options = parArr;
            formArr.unshift(formItem);
            this.isCanSelect = false; // 解锁字段展现列表
            this.targetColumnsData = formArr;
            this.allformulaFields = cloneDeep(this.targetColumnsData[0].options);
            this.searchData = field.allList;
            this.cakeData = field.allList;
            this.formData = selected;
            if (init) {
                this.tableColumns = cloneDeep(this.modelData.dragTableColumns);
                let temNewAllformulaFields = [];
                let tableColumnsMap = new Map();
                this.allformulaFields.forEach(item => {
                    tableColumnsMap.set(item.id, item);
                });
                this.tableColumns.forEach(item => {
                    if (!tableColumnsMap.has(item.id)) {
                        temNewAllformulaFields.push(item);
                    }
                });
                if (!isEmpty(temNewAllformulaFields)) {
                    this.aggFiledsList = cloneDeep(temNewAllformulaFields);
                    this.allformulaFields = this.allformulaFields.concat(temNewAllformulaFields);
                }
                this.isShowtableColumnsList = true;
                this.tableLoadTimer = new Date().getTime();
                setTimeout(() => {
                    this.columnDrop();// 重新加载table
                }, 1000);
            }
            if (this.selectedAggField && this.selectedAggField.selectYdata) {
                this.changeYdata(this.selectedAggField.selectYdata);
            }
        },
        chooseTargetColumns (e, field) {
            // 拿到当前数据源数据,然后更新展示数据
            if (e) {
                this.tableColumns = [];
                this.isShowtableColumnsList = false;
                for (var j = 0; j < e.length; j++) {
                    let yobj = this.targetColumnsData[0].options.find(y => y.id === e[j]);
                    this.tableColumns.push(yobj);
                }
                if (!isEmpty(this.aggFiledsList)) {
                    for (var a = 0; a < this.aggFiledsList.length; a++) {
                        this.tableColumns.push(this.aggFiledsList[a]);
                    }
                }
            } else if (field) {
                this.aggFiledsList.push(field);
                this.tableColumns.push(field);
            } else {
                return;
            }
            this.triggerFieldList();
        },
        synAddFileds (aggField) { // 同步增加聚合字段
            // console.log(aggField);
            // console.log(this.modelData.fieldFormulas);
            this.chooseTargetColumns(null, aggField);
            this.modelData.fieldFormulas.push(aggField);
            // console.log(aggField);
            this.synConfigFileds(aggField);
            this.allformulaFields.push(aggField);
            // console.log(this.allformulaFields);
        },
        synConfigFileds (aggField) { // 同步增加聚合字段
            // console.log(aggField);
            // console.log(this.modelData.fieldFormulas);
            // this.selectedAggField = {};
            if (isEmpty(this.modelData.fieldFormulas)) {
                this.selectedAggField.name = aggField.label;
                this.selectedAggField.formulaView = aggField.formulaView ? aggField.formulaView : '';
                this.selectedAggField.formulaDesc = aggField.formulaDesc ? aggField.formulaDesc : '';
                this.selectedAggField.formulaRule = aggField.formulaRule ? aggField.formulaRule : '';
                this.selectedAggField.id = aggField.id;
            } else {
                for (var i = 0; i < this.modelData.fieldFormulas.length; i++) {
                    if (this.modelData.fieldFormulas[i].id === aggField.id) {
                        this.selectedAggField = this.modelData.fieldFormulas[i];
                        break;
                    }
                }
            }
            if (this.selectedAggField) {
                if (this.selectedAggField.selectYdata) {
                    this.changeYdata(this.selectedAggField.selectYdata);
                }
            }
        },
        synDelFileds (aggField) { // 同步减去聚合字段
            // console.log(aggField);
            if (!isEmpty(this.aggFiledsList)) {
                for (var a = 0; a < this.aggFiledsList.length; a++) {
                    if (this.aggFiledsList[a].id === aggField.id) {
                        this.aggFiledsList.splice(a, 1);
                        break;
                    }
                }
                for (var index = 0; index < this.tableColumns.length; index++) {
                    if (this.tableColumns[index].id === aggField.id) {
                        this.tableColumns.splice(index, 1);
                        break;
                    }
                }
            }
            for (var i = 0; i < this.allformulaFields.length; i++) {
                if (this.allformulaFields[i].id === aggField.id) {
                    this.allformulaFields.splice(i, 1);
                    break;
                }
            }
            if (aggField.id === this.selectedAggField.id) {
                this.selectedAggField.id = '';
                this.selectedAggField.name = '';
                this.selectedAggField.formulaView = '';
                this.selectedAggField.formulaDesc = '';
                this.selectedAggField.formulaDesc = '';
                // console.log(this.selectedAggField);
            }
            this.triggerFieldList();
        },
        triggerFieldList () {
            this.modelData.dragTableColumns = cloneDeep(this.tableColumns);
            // console.log(this.modelData.dragTableColumns);
            this.isShowtableColumnsList = true;
            this.tableLoadTimer = new Date().getTime();
            setTimeout(() => {
                this.columnDrop();// 重新加载table
            }, 1000);
        },
        messageTip (msg, type) {
            this.$message({
                message: msg,
                type: type,
                duration: 3000
            });
        },
        randomNum (m, n) {
            var num = Math.floor(Math.random() * (m - n) + n);
            return num;
        },
        async saveData () {
            if (this.modelData.modelName === undefined || this.modelData.modelName.trim() === '') {
                this.messageTip('请输入聚合表名称', 'warning');
                return;
            }
            if (this.modelData.selectModelId === undefined || this.modelData.selectModelId.trim() === '') {
                this.messageTip('请选择数据模型', 'warning');
                return;
            }

            if (this.modelData.selectTargetColumns === undefined || isEmpty(this.modelData.selectTargetColumns)) {
                this.messageTip('请选择字段', 'warning');
                return;
            }
            let tableObj = {};
            tableObj.id = this.modelData.id;
            tableObj.modelName = this.modelData.modelName;
            tableObj.remarks = this.modelData.remarks;
            tableObj.dataSourceType = this.modelData.dataSourceType;
            tableObj.formId = this.modelData.formId;
            tableObj.modelId = this.modelData.modelId;
            tableObj.selectFormId = this.modelData.selectFormId;
            tableObj.selectModelId = this.modelData.selectModelId;
            tableObj.selectTargetColumns = JSON.stringify(this.modelData.selectTargetColumns);
            tableObj.dragTableColumns = JSON.stringify(this.modelData.dragTableColumns);
            tableObj.fieldFormulas = JSON.stringify(this.modelData.fieldFormulas);
            tableObj.searchConditionFields = JSON.stringify(this.modelData.searchConditionFields);
            tableObj.timeSettingFields = JSON.stringify(this.modelData.timeSettingFields);
            tableObj.viewConditionFields = JSON.stringify(this.modelData.viewConditionFields);
            let param = {
                id: this.aggregateTableConfigData.formId,
                appId: this.aggregateTableConfigData.appId,
                modelId: this.aggregateTableConfigData.modelId,
                modelName: this.modelData.modelName,
                formName: this.modelData.modelName,
                remarks: this.modelData.remarks,
                modelType: 6,
                formAggregateTable: tableObj

            };
            // console.log(param);
            this.$emit('saveTableData', param);
        },
        fillterCondtionSearch () {
            // 修改和新增
            if (this.conditionFields.length > 0) {
                this.isShowBiSearchSetting = true;
            } else {
                let param = {dataModelId: this.modelData.selectModelId, dataFormId: this.modelData.selectFormId};
                this.renderFormList(param, true, null);
                this.isShowBiSearchSetting = true;
            }
        },
        celSetForm () {
            this.conditionFields = [];
            this.isShowBiSearchSetting = false;
        },
        async resetSearchConditon () {
            this.conditionFields.length = 0;
            this.fillterCondtionSearch();
        },
        subSetForm () {
            let search = cloneDeep(this.conditionFields);
            // let obj = this.allChooseContrastData.find(i => i.index == this.currItem.index);
            // obj.conditionFields = search;
            this.modelData.searchConditionFields = search;
            this.isShowBiSearchSetting = false;
        },
        async refreshSearchConditon (columns) {
            this.conditionFields.length = 0;
            let idArr = [];
            columns.forEach(item => {
                idArr.push(item.id);
            });
            let cfs = await getFormFieldListByIds(idArr.join(','));
            this.conditionFields = [];
            if (cfs && cfs.length > 0) {
                for (var i = 0; i < cfs.length; i++) {
                    if (cfs[i].type === 'subform') {
                        continue;
                    } else {
                        this.conditionFields.push(cfs[i]);
                    }
                }
            }
            this.searchLoadTimer = new Date().getTime();
        },
        async renderFormList (model, isInitSearch, searchCondition) {
            this.searchParams.searchCondition = [];
            this.searchParams.modelId = model.dataModelId;
            this.searchParams.formId = model.dataFormId;
            this.searchParams.modelType = model.modeType;
            this.searchParams.isFilterDuplicateData = false;
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let formData = await getModelFormReportList(Object.assign({}, {
                currentPage: this.formPage.currentPage,
                pageSize: this.formPage.pageSize
            }, this.searchParams));
            if (formData.otherData && formData.otherData.tableColumns) {
                this.tableColumns = [];
                let _tableColumns = formData.otherData.tableColumns;
                _tableColumns.forEach(item => {
                    if (item.type !== 'divider') { // 隐藏分割线
                        this.tableColumns.push(item);
                    }
                });
            }
            this.refreshSearchConditon(this.tableColumns);
            loading.close();
        },
        async chooseViewFields () {
            this.isShowFilterField = false;
            this.tableColumns = [];
            let tempFields = this.$refs.selectMultiple.getSelectViewFields();
            // console.log(tempFields);
            if (tempFields.length > 0) {
                // this.resetViewFields();
                tempFields.forEach((item) => {
                    this.tableColumns.push({prop: item.id, label: item.name});
                });
            }
            this.isRefreshCondition = true;
            // this.selectViewFields=tempFields;
            // console.log(this.tableColumns);
            this.$emit('setTableColumns', this.tableColumns);
        },
        resetViewFields () {
            this.tableColumns = [];
            // this.$emit('setTableColumns', this.tableColumns);
        },
        handleSaveCalculation () {
            this.isSummary = false;
            this.loadTimer = new Date().getTime();
            this.sourceOptions = [];
            this.content.txt = '';
            if (this.selectedAggField.formulaView) {
                this.content.txt = this.selectedAggField.formulaView;
            }
            // console.log(this.allformulaFields);
            this.setSourceOptions(this.allformulaFields);
            // console.log(this.sourceOptions);
            if (this.sourceOptions.lengh === 0) {
                this.$message({message: '当前表单未定义数字类型字段', type: 'warning'});
                return;
            }
            // console.log(this.sourceOptions);
            this.isShowFormula = true;
        },
        setSourceOptions (fieldsList) {
            fieldsList.forEach(item => {
                // if (item.type === 'number' || item.type === 'calculation' || item.type === 'subFormSummary') { // 仅支持数字类型的字段进行计算公式设计
                let data = {type: 0};
                data.id = item.id;
                data.label = item.name;
                if (item.id.length === 32) {
                    data.type = 1;
                }
                this.sourceOptions.push(data);
                // } else if (item.type === 'subform' && item.options.fieldList) {
                //     this.setSourceOptions(item.options.fieldList);
                // }
            });
        },
        saveFormula () {
            // setTimeout(() => { // 调用子组件的方法
            let formula = this.$refs.formula.transformFormula();// 每次切换model时清空显示字段
            // console.log(this.content);
            this.selectedAggField.formulaExp = formula;
            this.selectedAggField.formulaView = this.content.txt;
            // console.log(this.searchData);
            // console.log(formula);
            this.allformulaFields.forEach(item => {
                if (formula.indexOf(item.id) !== -1) {
                    let temp = formula.replace(new RegExp(item.id, 'gm'), item.name);// replaceAll
                    formula = temp.trim();
                }
            });
            this.selectedAggField.formulaRule = formula.trim();
            // let isIn = false;
            for (var i = 0; i < this.modelData.fieldFormulas.length; i++) {
                if (this.modelData.fieldFormulas[i].id === this.selectedAggField.id) {
                    this.modelData.fieldFormulas.splice(i, 1);
                    this.modelData.fieldFormulas.push(this.selectedAggField);
                    // isIn = true;
                    break;
                }
            }
            // if (!isIn) {
            //     this.modelData.fieldFormulas.push(this.selectedAggField);
            // }
            this.isShowFormula = false;
            // console.log(this.modelData.fieldFormulas);
        },
        changeXdata (e) {
            // let list = this.allFields.find(i => i.id === e);
            // let currentData = {id: e, name: list.name, type: list.type, fieldType: list.fieldType, parentId: list.parentId};
            // this.allChooseXdata = currentData;
            // this.dynamicBiData(currentData, 1);
            // console.log(this.selectedAggField);
        },
        async changeYdata (e) {
            let field = this.allFields.find(i => i.id === e);
            if (field && field.formId) {
                let formData = await getFormConfig(field.formId);
                this.aggregateSearchConditionFields = formData.fieldsList;
                this.aggregateFieldsLoadTimer = new Date().getTime();
            } else {
                this.aggregateSearchConditionFields = [];
            }

            // let currentData = {id: e, name: list.name, type: list.type, fieldType: list.fieldType, parentId: list.parentId};
            // this.allChooseXdata = currentData;
            // this.dynamicBiData(currentData, 1);
            // console.log(this.selectedAggField);
        },
        changeOpreaYdata () {
            // console.log(this.selectedAggField);
        },
        async handleFilterTimeSetting () {
            this.isTimeSettingFields = false;
            if (this.modelData && this.modelData.timeSettingFields && Array.isArray(this.modelData.timeSettingFields) && this.modelData.timeSettingFields.length > 0) {
                this.timeSettingFields = this.modelData.timeSettingFields;
                // this.originalTimeSettingFields = cloneDeep(this.timeSettingFields);
            } else {
                if (this.isRefreshTimeSetting) {
                    await this.resetTimeSettingFields();
                    this.isRefreshTimeSetting = false;
                }
            }
            this.isTimeSettingFields = true;
        },
        async chooseTimeSettingFields () {
            let timeSettingFields = this.$refs.timeSettingFields.getTimeSettingFields();
            // this.searchParams.timeSettingFields = timeSettingFields;
            // let obj = this.allChooseContrastData.find(i => i.index == this.currItem.index);
            // obj.conditionFields = search;
            this.modelData.timeSettingFields = timeSettingFields;
            this.isTimeSettingFields = false;
        },
        async resetTimeSettingFields () {
            if (isEmpty(this.originalTimeSettingFields)) {
                let idArr = [];
                if (this.targetColumnsData && this.targetColumnsData[0].options) {
                    let fields = this.targetColumnsData[0].options;
                    for (let j = 0; j < fields.length; j++) {
                        let field = fields[j];
                        if (field.type === 'date') {
                            idArr.push(field.id);
                        }
                    }
                    if (idArr.length > 0) {
                        this.loadTimer = new Date().getTime();
                        let loading = this.$loading({
                            lock: true,
                            text: 'Loading',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        this.timeSettingFields = await getFormFieldListByIds(idArr.join(','));
                        loading.close();
                        this.originalTimeSettingFields = cloneDeep(this.timeSettingFields);
                    }
                }
            } else {
                this.loadTimer = new Date().getTime();
                this.timeSettingFields = cloneDeep(this.originalTimeSettingFields);
            }
        }
    }
};
</script>

<style lang="less" scoped="scoped">
.aggregateTable-content {
    height: 100%;
    width: ~"calc(100% - 66px)";
    top: 0vh;
    overflow: auto;
    position: absolute;
    .aggregateTable-content-top{
       display: flex;
       height:6vh;
       line-height: 6vh;
       .tit{
           flex: 1;
           font-size: 1.25rem;
           font-weight: 400;
           text-align: left;
       }
       .btn{
           flex: 1;
           text-align: right;
       }
    }
    .aggregateTable-content-main{
        display: flex;
        height: ~"calc(100% - 9vh)";;
        .aggregateTable-content-main-left{
            width: 220px;
            padding: 10px 10px;
            border: 1px solid #F0F0EE;
            overflow: auto;
            padding-bottom: 30px;
            .aggregateTable-content-main-left-item{
                height: 80px;
                .item-lable{
                   height: 30px;
                   line-height: 30px;
                }
                .requireClass:before {
                      content: "*";
                      color: #f56c6c;
                      margin-right: 4px;
                    }
                .item-content{
                    height: 50px;
                    line-height: 50px;
                }
                .add-contrast-field,.del-contrast-field{
                    cursor: pointer;
                    border: 1px solid #f2f2f2;
                    border-radius: 4px;
                    text-align: center;
                    height: 30px;
                    line-height: 30px;
                }
                .add-contrast-field:hover,.del-contrast-field:hover{
                    border: 1px solid #7ec2f7;
                    color: #7ec2f7;
                }
            }
            .Bi-type{
                height:140px;
                .item-content{
                    height: 110px;
                    line-height: 110px;
                    .bi-type-item{
                        width: 58px;
                        height: 60px;
                        line-height: 60px;
                        float: left;
                        text-align: center;
                        .active {
                            border: 2px solid #009ed0;
                            border-radius: 2px;
                        }
                        .icon{
                            width: 36px;
                            height: 36px;
                            margin-top: 12px;
                            cursor: pointer;
                        }
                        .icon:hover{
                            width: 40px;
                            height: 40px;
                            margin-top: 10px;
                        }
                    }
                }
            }
            .bi-field{
                height: auto;
                margin-top: 10px;
                .item-content{
                    height: auto;
                    .el-collapse{
                        width: 98%;
                        border: 1px solid #ebeef5;
                        padding-left: 10px;
                        margin-top: 4px;
                        .bi-field-calcul{
                            margin-top: 10px;
                           .el-select{
                               width: 88%;
                           }
                        }
                        .bi-field-calcul-format{
                             margin-top: 10px;
                            .el-select{
                                width: 88%;
                            }
                        }
                        .bi-field-calcul-type{
                            margin-top: 10px;
                            .el-select{
                                width: 88%;
                            }
                        }
                        .bi-field-alias{
                           margin-top: 10px;
                           .el-input{
                               width: 88%;
                           }
                        }
                        .bi-field-statistics{
                            margin-bottom: 10px;
                            .el-select{
                                width: 88%;
                            }
                        }
                        .del-contrast-field{
                            width: 88%;
                            margin-top: 10px;
                        }
                    }
                }
                padding-bottom: 15px;
            }
        }
        .aggregateTable-content-main-right{
            width: 1160px;
            flex:1;
            padding: 10px 10px;
            border: 1px solid #F0F0EE;
            border-left:none;
            .customAggregateConfig-detail {
              margin-top: 1px;
              width: 100%;
              // height: 100%;
              overflow-y: auto;

              .el-collapse-item__wrap {
                  padding: 0 20px;
              }

              .el-collapse {
                  width: 100%;
              }
              .model-btns {
                  height: 80px;
                  padding: 0 10px 0 0;
              }
              .model-desc {
                  margin: 20px 15px;
                  .el-card__body {
                      height: 15px;
                      display: flex;
                      flex-direction: row;
                      justify-content: space-between;
                      .topSetting {
                          margin-top: -10px;
                      }
                  }
              }
              .model-content {
                  flex: 1;
                  margin: 0 15px;

                  display: flex;
                  flex-direction: row;
              }
              .content-left {
                  width: 100%;
                  margin: 0 15px 0 0;
              }
              .comments {
                  width: 300px;
              }
          }
        }
    }
    /deep/ .search-field-box{
        height: 100% !important;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomAggregateTable/CustomAggregateTable.vue